var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4992 4.78516C11.8844 4.78516 4.90002 11.77 4.90002 20.386C4.90002 27.2784 9.36882 33.1256 15.5684 35.1872C16.3492 35.3316 16.6332 34.8512 16.6332 34.4364C16.6332 34.0668 16.6196 33.0864 16.6128 31.7832C12.2732 32.7268 11.3576 29.6916 11.3576 29.6916C10.648 27.8896 9.62522 27.4104 9.62522 27.4104C8.20882 26.4432 9.73282 26.462 9.73282 26.462C11.2984 26.5728 12.1224 28.0692 12.1224 28.0692C13.5136 30.4532 15.774 29.7632 16.6624 29.3664C16.8036 28.3564 17.2076 27.6704 17.6528 27.2796C14.1892 26.886 10.5476 25.5476 10.5476 19.57C10.5476 17.8664 11.1552 16.4736 12.1528 15.3828C11.9932 14.99 11.4568 13.404 12.306 11.2552C12.306 11.2552 13.6156 10.836 16.5964 12.8556C17.84 12.508 19.1748 12.3344 20.5016 12.3292C21.8264 12.3348 23.1616 12.508 24.4068 12.8556C27.3856 10.836 28.6932 11.2552 28.6932 11.2552C29.5444 13.404 29.0084 14.99 28.8484 15.3828C29.8484 16.4736 30.4516 17.8664 30.4516 19.57C30.4516 25.5616 26.8048 26.8816 23.3296 27.2664C23.8888 27.7484 24.388 28.7024 24.388 30.158C24.388 32.2424 24.3692 33.9244 24.3692 34.436C24.3692 34.854 24.6496 35.34 25.4416 35.1852C31.6344 33.1192 36.1 27.2764 36.1 20.386C36.1 11.77 29.1156 4.78516 20.4992 4.78516Z",
    fill: "url(#paint0_linear_1048_33687)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1048_33687",
    x1: 4.90002,
    y1: 20.1603,
    x2: 37.5198,
    y2: 20.1557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00394562,
    stopColor: "#F44554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3271E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.fd78f4720a6e71a5d1ba128788f47af8.svg";
export { ForwardRef as ReactComponent };